import dayjs from 'dayjs'
import { useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { ESTADO_PUBLICADA } from '../../constants/publicaciones'
import { setCategoriaPath } from '../../slices/filterSlice'
import { CarritoContext } from '../context/carritoContext'
import { LoginContext } from '../context/loginContext'
import CalificacionProducto from '../publicaciones/calificacionProducto/CalificacionProducto'
import Descripcion from '../publicaciones/Descripcion'
import DetalleCabecera from '../publicaciones/DetalleCabecera'
import InformacionVendedor from '../publicaciones/InformacionVendedor'
import { MensajeriaNew } from '../reutilizables/mensajeria/MensajeriaNew'
import * as calificacionService from '../servicios/calificacionService'
import * as datosFiscalesService from '../servicios/datosFiscalesService'
import * as provinciasService from '../servicios/fetchProvinciasAPI'
import * as mensajesService from '../servicios/mensajesService'
import * as publicacionesService from '../servicios/publicacionesService'
import * as reputacionService from '../servicios/reputacionService'
import BordeDetalle from '../ui/BordeDetalle'
import styles from './PublicacionDetalle.module.css'

const PublicacionDetalle = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const { loginDataContext } = useContext(LoginContext)
  const tipoUsuario = loginDataContext.tipoUsuario
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [publicacion, setPublicacion] = useState([])
  const [reputacion, setReputacion] = useState(0)
  const [calificacion, setCalificacion] = useState(0)
  const [mensajes, setMensajes] = useState([])
  const [datosFiscales, setDatosFiscales] = useState([])
  const [provincias, setProvincias] = useState([])
  const { setCantidadCompra } = useContext(CarritoContext)

  const buscarMensajes = async () => {
    const { data } = await mensajesService.buscarPorPublicacion(id)
    const mapa = {}
    data.forEach((msj) => {
      if (!msj.idMensajePadre) mapa[msj.idMensaje] = { ...msj }
    })
    data.forEach((msj) => {
      if (msj.idMensajePadre && mapa[msj.idMensajePadre] && !mapa[msj.idMensajePadre].textoRta) {
        mapa[msj.idMensajePadre].textoRta = msj.texto
        mapa[msj.idMensajePadre].fechaEscritoRta = msj.fechaEscrito
      }
    })
    const roots = Object.values(mapa).sort((a, b) => {
      const aMia = a.idComprador === usuario || a.idUsuarioChat === usuario ? 1 : 0
      const bMia = b.idComprador === usuario || b.idUsuarioChat === usuario ? 1 : 0
      if (bMia !== aMia) return bMia - aMia
      return dayjs(b.fechaEscrito).diff(dayjs(a.fechaEscrito))
    })
    setMensajes(roots)
  }

  const obtenerPublicacion = async () => {
    const publicacionRes = await publicacionesService.buscarDetalle(id)
    const publicacionData = publicacionRes.data
    setPublicacion(publicacionData)

    const reputacionRes = await reputacionService.buscarReputacion(publicacionData.idVendedor)
    setReputacion(reputacionRes.data)

    const calificacionRes = await calificacionService.buscarCalificacion(id)
    setCalificacion(calificacionRes.data)

    const datosFiscalesRes = await datosFiscalesService.buscarTodos(publicacionRes.data.idVendedor)
    setDatosFiscales(datosFiscalesRes.data)

    const provinciasRes = await provinciasService.buscarProvinciasEnEBM()
    setProvincias(provinciasRes.data)

    await buscarMensajes()
  }

  const mostrarMensajeImpuestos = () => {
    if (!datosFiscales || datosFiscales.length === 0) {
      return false
    }
    return datosFiscales.some((df) => df.esAgentePercepcion === true)
  }

  const obtenerProvinciasPercepcion = () => {
    if (!datosFiscales || datosFiscales.length === 0 || !provincias || provincias.length === 0) {
      return []
    }

    const idsProvincias = datosFiscales
      .filter((df) => df.esAgentePercepcion === true)
      .map((df) => Number(df.idProvincia))

    const nombresProvincias = provincias
      .filter((p) => idsProvincias.includes(Number(p.idProvincia)))
      .map((p) => p.nombre)

    return nombresProvincias
  }

  useEffect(() => {
    obtenerPublicacion()
    setCantidadCompra(1)
  }, [id])

  const onCerrarClick = () => {
    navigate(-1)
    setCantidadCompra(1)
  }

  const buildCategoriaLinks = () => {
    if (!publicacion?.categoriaRoot) return null
    try {
      const path = JSON.parse(publicacion.categoriaRoot)
      if (!Array.isArray(path) || path.length === 0) return null
      return path.map((cat, index) => ({
        id: cat.id,
        name: cat.name,
        onClick: () => {
          dispatch(
            setCategoriaPath(path.slice(0, index + 1).map((c) => ({ id: c.id, label: c.name })))
          )
          navigate('/Publicaciones', { state: { desdeCategoria: true } })
        }
      }))
    } catch {
      return null
    }
  }

  return (
    <BordeDetalle
      titulo={`Categoria: ${publicacion?.categorias}`}
      categoriaLinks={buildCategoriaLinks()}
      onCerrarClick={() => onCerrarClick()}
    >
      <DetalleCabecera
        detalle={publicacion}
        permiteComprar={
          publicacion?.idVendedor !== usuario &&
          publicacion.idPublicacionEstado === ESTADO_PUBLICADA
        }
        calificacion={calificacion}
        onScrollCalificacion={() =>
          document.getElementById('calificacion-producto')?.scrollIntoView()
        }
      />
      <div className={styles.flexContainer}>
        <div className={styles.columnaIzq}>
          <Descripcion
            descripcion={publicacion?.descripcion}
            idPublicacion={publicacion?.idPublicacion}
          />
          <MensajeriaNew
            titulo={'Preguntas'}
            id={id}
            tipoDoc={'publicacion'}
            idVendedor={publicacion?.idVendedor}
            mensajes={mensajes}
            tipoMensajes={'preguntas'}
            usuario={usuario}
            idComprador={usuario}
            actualizarMensajes={buscarMensajes}
            idPublicacionEstado={publicacion?.idPublicacionEstado}
          />
        </div>
        <div className={styles.columnaDer}>
          {tipoUsuario !== 'R' && mostrarMensajeImpuestos() && (
            <div className={styles.noticeBox}>
              <strong>Importante:</strong> Este vendedor es agente de percepción en
              {obtenerProvinciasPercepcion().length > 0 && (
                <> {obtenerProvinciasPercepcion().join(', ')}</>
              )}
              . Al confirmar la compra vas a visualizar el cálculo correspondiente de impuestos.
            </div>
          )}
          <InformacionVendedor
            reputacion={reputacion.length > 0 ? reputacion : 0}
            publicacion={publicacion}
          />
          {calificacion.length > 0 && (
            <div id="calificacion-producto">
              <CalificacionProducto calificacion={calificacion} />
            </div>
          )}
        </div>
      </div>
    </BordeDetalle>
  )
}

export default PublicacionDetalle
